export default {
  name: 'Default',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    visible: Boolean,
    transition: {
      type: String,
      default: 'fade',
    }
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      show: this.visible,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    enterClass () {
      return `${this.transition}In`;
    },

    leaveClass () {
      return `${this.transition}Out`;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    this.$lib._$id('popup_layer').appendChild(this.$el);
    this.$lib._$id('popup_layer').style.display = 'block';
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    beforeEnter () {
      this.$emit('open');
    },

    afterLeave () {
      this.$emit('close');
    },

    active () {
      this.show = true;
    },

    deactive () {
      this.show = false;
    },

    remove () {
      this.$lib._$id('popup_layer').removeChild(this.$el);
      this.$lib._$id('popup_layer').style.display = 'none';
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
    visible (val) {
      this.show = val;
    }
  },
};
